import { createFileRoute } from '@tanstack/react-router'
import { Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@shadcn/button'

export const Route = createFileRoute('/session/password-reset/link-sent')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center gap-4">
        <Check className="size-6 text-green-500" />
        <h1 className="text-2xl font-bold">
          {t('session.password-reset.ask.asked.title')}
        </h1>
      </div>
      <p className="text-sm text-gray-500">
        {t('session.password-reset.ask.asked.description')}
      </p>
      <Route.Link to="../../login">
        <Button size="ghost" variant="ghostPrimary" className="w-full">
          {t('session.password-reset.ask.asked.button')}
        </Button>
      </Route.Link>
    </div>
  )
}
